
import ThemeToggle from '@/components/theme/ThemeToggle';
import { CommandMenu } from '@/components/layout/CommandMenu';
import { NotificationsPopover } from './NotificationsPopover';
import { UserProfileDropdown } from './UserProfileDropdown';
import { PhoneDialerButton } from './PhoneDialerButton';

export const NavbarActions = () => {
  return (
    <div className="flex items-center space-x-2 md:space-x-4">
      <div className="relative hidden md:block">
        <CommandMenu />
      </div>
      
      <div className="flex items-center space-x-1 md:space-x-2">
        <PhoneDialerButton />
        <ThemeToggle />
        <NotificationsPopover />
        <UserProfileDropdown />
      </div>
    </div>
  );
};
